import * as React from "react";

import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import { ButtonFixed, Col, Icon, Loading, Table, Td, Th } from "styleguide";

import { fetchJournalists } from "../actions/journalist";
import { clearSearch, doSearch } from "../actions/search";
import SearchForm from "../components/SearchForm";
import config from "../config";
import { IState } from "../reducers";
import { requestJournalistsSearched } from "../services/journalist";
import { createDefaultSearch } from "../services/search";
import * as errors from "../types/errors";
import IJournalist from "../types/journalist";
import ISearch from "../types/search";
import debounce from "../utils/debounce";
import { Helmet } from "react-helmet";

interface IPropsFromState {
    journalists: IJournalist[];
    error?: errors.HttpError;
    isLoading: boolean;
    offset: number;
    search: ISearch;
}

interface IPropsFromDispatch {
    fetchJournalists: typeof fetchJournalists;
    doSearch: typeof doSearch;
    clearSearch: typeof clearSearch;
}

class MyComponent extends React.Component<IPropsFromState & IPropsFromDispatch & RouteComponentProps<{}>> {
    public renderListJournalists = () => {
        const { history } = this.props;
        const journalists = this.props.journalists.map((j) => {
            j.newspapersName = j.newspapers && j.newspapers.map((n) => n.newspaperName).join(", ");

            return j;
        });

        return (
            <Col s={12}>
                <Table title="Journalists">
                    <thead>
                        <tr>
                            <Th size="small">Id</Th>
                            <Th>Name</Th>
                            <Th hide="mobile">Newspapers</Th>
                            <Th align="right">Actions</Th>
                        </tr>
                    </thead>
                    <tbody>
                        {journalists.map((journalist) => (
                            <tr key={journalist.journalistId}>
                                <Td>{journalist.journalistId}</Td>
                                <Td>{journalist.journalistName}</Td>
                                <Td>{journalist.newspapersName}</Td>
                                <Td align="right">
                                    <a href={`/journalists/${journalist.journalistId}`}>
                                        <Icon icon="edit" />
                                    </a>
                                </Td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <ButtonFixed icon="add" onClick={() => history.push(`${config.paths.journalist}+`)} />
            </Col>
        );
    };

    public renderSearch = () => {
        return <SearchForm onSubmit={this.submitForm} />;
    };

    public submitForm = (search: ISearch | any) => {
        this.props.doSearch(search);

        this.props.fetchJournalists(requestJournalistsSearched(search), true);
    };

    public componentDidMount() {
        window.onscroll = () => {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
                debounce(() => {
                    this.props.fetchJournalists(requestJournalistsSearched(this.props.search), false);
                });
            }
        };
        this.props.fetchJournalists(requestJournalistsSearched(createDefaultSearch()), true);
    }

    public componentWillUnmount() {
        this.props.clearSearch();
        window.onscroll = null;
    }

    public render() {
        const { isLoading } = this.props;

        return (
            <React.Fragment>
                {/* 
                // @ts-ignore */}
                <Helmet>
                    <title>Journalists</title>
                </Helmet>
                {isLoading && <Loading />}
                {this.renderSearch()}
                {this.renderListJournalists()}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: IState): IPropsFromState {
    return {
        error: state.journalist.error,
        isLoading: state.journalist.isLoading,
        journalists: state.journalist.journalists,
        offset: state.journalist.offset,
        search: state.search,
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators(
        {
            clearSearch,
            doSearch,
            fetchJournalists,
        },
        dispatch,
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyComponent));
